const initialState = {
  firstTime: true,
  customerDetails: null,
  userIdInput: null,
  isLoggedInUser: false,
};

const customerReducer = (state = initialState, action) => {
  if (!action) return state;
  switch (action.type) {
    case "FIRST_TIME_TRUE":
      return {
        ...state,
        firstTime: action.payload,
      };
    case "FIRST_TIME_FALSE":
      return {
        ...state,
        firstTime: action.payload,
      };
    case "SET_CUSTOMER_DETAILS":
      return {
        ...state,
        customerDetails: action.payload,
      };
    case "SET_INP_USER_ID":
      return {
        ...state,
        userIdInput: action.payload,
      };
    case "SET_IS_LOGGED_IN_USER":
      return {
        ...state,
        isLoggedInUser: action.payload,
      };
    default:
      return state;
  }
};

export default customerReducer;
